import { Dispatch } from 'react'
import * as api from '../services/api'
import { AppState } from '../../../global/store'
import { DashboardAction } from './reducers'
import { PartnerSummaryState } from './store'
import { ActionError } from '../../../global/errors'
import { RequestState } from '../../types'

import {
  LOAD_PARTNER_SUMMARY_ERROR,
  LOAD_PARTNER_SUMMARY_RECEIVED,
  LOAD_PARTNER_SUMMARY_REQUEST,
  SUBSCRIPTION_CHART_ERROR,
  SUBSCRIPTION_CHART_RECEIVED,
  SUBSCRIPTION_CHART_REQUEST
} from './reducers'

import moment from 'moment'

export function loadPartnerSummary(partnerId: string) {
  return async function (state: AppState, dispatch: Dispatch<DashboardAction>) {
    try {
      dispatch({
        type: LOAD_PARTNER_SUMMARY_REQUEST,
        partnerId
      })

      const summary = await api.getPartnerSummary(partnerId)

      dispatch({
        type: LOAD_PARTNER_SUMMARY_RECEIVED,
        partnerId,
        summary: mapPartnerSummary(summary.data.stats.data)
      })
    } catch (error) {
      throw new ActionError(LOAD_PARTNER_SUMMARY_ERROR, error)
    }
  }
}

export function loadSubscriptionGraphData(partnerId: string) {
  return async function (state: AppState, dispatch: Dispatch<DashboardAction>) {

    try {
      dispatch({
        type: SUBSCRIPTION_CHART_REQUEST
      })

      const graphData = await api.getPartnerSubscriptionChartData(partnerId)

      const added = { id: "added", data: graphData.map((p: any) => ({ x: formatXValue(p.period), y: p.added}))}
      const deactivated = { id: "deactivated", data: graphData.map((p: any) => ({ x: formatXValue(p.period), y: p.deactivated}))}

      dispatch({
        type: SUBSCRIPTION_CHART_RECEIVED,
        data: [deactivated, added]
      })
    } catch (error) {
      dispatch({
        type: SUBSCRIPTION_CHART_ERROR
      })
    }
  }
}

function formatXValue(value: string) {
  const dt = moment(value)
  return dt.format("MMM YY")
}

function mapPartnerSummary(summary: any): PartnerSummaryState {
  return {
    subscriptionsAddedMonth: summary.subscriptions_added_month,
    subscriptionsDeactivatedMonth: summary.subscriptions_deactivated_month,
    totalSubscriptions: summary.total_subscriptions,
    trialSubscriptions: summary.trial_subscriptions,
   requestState: RequestState.Loaded
  }
}
